<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container das-form-group">
        <el-row :gutter="16" class="das-form-row">
          <el-col :span="4" class="das-form-col">
            <div class="das-form-input">
              <div class="label">
                {{ 'Mã đặt phòng' }}
              </div>
              <input v-model="searchParams.bookingId" type="text" />
            </div>
          </el-col>
          <el-col :span="8" class="das-form-col">
            <el-row :gutter="16">
              <el-col :span="12">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Số điện thoại' }}
                  </div>
                  <input
                    v-model="searchParams.phone"
                    type="text"
                    placeholder="Số điện thoại"
                  />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="das-form-input">
                  <div class="label">
                    {{ 'Tên' }}
                  </div>
                  <input
                    v-model="searchParams.firstName"
                    type="text"
                    placeholder="Tên"
                  />
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <div class="das-form-input">
              <div class="label">
                {{ 'Nguồn' }}
              </div>
              <el-select v-model="searchParams.sourceId" filterable clearable>
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.id"
                  :label="item.desc"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="das-form-input">
              <div class="label">
                {{ 'Công ty đại lý du lịch' }}
              </div>
              <el-select v-model="searchParams.agentId" filterable clearable>
                <el-option
                  v-for="item in agencyOptions"
                  :key="item.id"
                  :label="`(${item.code})${item.name}`"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 16px" :gutter="16" class="das-form-row">
          <el-col :span="8" class="das-form-col">
            <div class="das-form-input">
              <div class="checkbox-wrap">
                <label for="arrival_date_range_enabled">
                  <span class="label">{{ 'Ngày đến' }}</span>
                </label>
              </div>
              <div style="position: relative">
                <CalendarRange
                  v-model="arrival_date_range"
                  mode="date"
                ></CalendarRange>
              </div>
            </div>
          </el-col>
          <el-col :span="8" class="das-form-col">
            <div class="das-form-input">
              <div class="checkbox-wrap">
                <label for="departure_date_range_enabled">
                  <span class="label">{{ 'Ngày đi' }}</span>
                </label>
              </div>
              <div style="position: relative">
                <CalendarRange
                  v-model="departure_date_range"
                  mode="date"
                ></CalendarRange>
              </div>
            </div>
          </el-col>
          <el-col :span="8" class="das-form-input">
            <div class="label">
              {{ 'Trạng thái đặt phòng' }}
            </div>
            <div
              style="
                display: flex;
                flex-wrap: wrap;
                gap: 8px 16px;
                white-space: nowrap;
              "
            >
              <div class="checkbox-wrap">
                <input
                  id="reservation-status-isBooked"
                  v-model="searchParams.isBooked"
                  type="checkbox"
                />
                <label for="reservation-status-isBooked">Đã đặt</label>
              </div>
              <div
                v-if="view == 'all' || view == 'arrived_guest'"
                class="checkbox-wrap"
              >
                <input
                  id="reservation-status-isArriveToDay"
                  v-model="searchParams.isArriveToDay"
                  type="checkbox"
                />
                <label for="reservation-status-isArriveToDay"
                  >Đến hôm nay</label
                >
              </div>
              <div v-if="view == 'all'" class="checkbox-wrap">
                <input
                  id="reservation-status-isInHouse"
                  v-model="searchParams.isInHouse"
                  type="checkbox"
                />
                <label for="reservation-status-isInHouse">Đang ở</label>
              </div>
              <div v-if="view == 'all'" class="checkbox-wrap">
                <input
                  id="reservation-status-isCanceled"
                  v-model="searchParams.isCanceled"
                  type="checkbox"
                />
                <label for="reservation-status-isCanceled">Đã hủy</label>
              </div>
              <div v-if="view == 'all'" class="checkbox-wrap">
                <input
                  id="reservation-status-isNotArrive"
                  v-model="searchParams.isNotArrive"
                  type="checkbox"
                />
                <label for="reservation-status-isNotArrive">Không đến</label>
              </div>
              <div v-if="view == 'all'" class="checkbox-wrap">
                <input
                  id="reservation-status-isCheckout"
                  v-model="searchParams.isCheckout"
                  type="checkbox"
                />
                <label for="reservation-status-isCheckout">Đã trả</label>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16" class="das-form-row"> </el-row>
        <el-row :gutter="16" class="das-form-row"> </el-row>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll mt-10">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        class="agGrid"
        dom-layout="scroll"
        :auto-size-cell="false"
        :auto-select-first-row="false"
        :is-row-selectable="params => !params.data?.isFullWidthRow"
        :row-multi-select-with-click="true"
        @cellContextMenu="handleOpenContextMenu"
        @selectionChanged="onSelectionChanged"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="pageParams.totalPage"
        :page-num="pageParams.pageNum"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small"
        @click="$router.push({ path: '/reservation/new_reservation' })"
      >
        {{ 'Tạo đặt phòng' }}
      </button>

      <button
        class="btn primary small"
        :disabled="
          !(
            selectedRows.length === 2 &&
            selectedRows.every(obj => isHeaderRow(obj)) &&
            selectedRows.every(obj => obj?.booking_type_nm !== 'Đoàn')
          )
        "
        @click="onJoinGroup"
      >
        {{ 'Ghép nhóm' }}
      </button>

      <button
        class="btn primary small"
        :disabled="
          !(
            selectedRows.length > 0 &&
            selectedRows.every(obj => !isHeaderRow(obj)) &&
            selectedRows.every(obj => obj?.room_id)
          )
        "
        @click="onCheckin"
      >
        {{ 'Check-in' }}
      </button>
      <button
        class="btn primary small"
        :disabled="
          !(
            selectedRows.length > 0 &&
            selectedRows.every(obj => !isHeaderRow(obj))
          )
        "
        @click="onCancel"
      >
        {{ 'Hủy đặt phòng' }}
      </button>
    </div>
    <RoutingDialog
      v-if="routingBookingInfo"
      v-model="dialogRoutingVisible"
      :customer-info="routingBookingInfo"
    />
    <CancelBookingDialog
      v-model="dialogCancelVisible"
      :data="selectedRows"
      @submit="onResetCancel"
    />
    <!-- context menu -->
    <nav v-show="ctxMenuState" id="context-menu" class="context-menu">
      <ul class="context-menu__items">
        <li class="context-menu__item" @click="() => getDetailBooking()">
          <a href="#" class="context-menu__link" data-action="View"
            ><i class="fa fa-eye"></i>Xem chi tiết
            {{ ctxMenuRow?.booking_type_nm }}</a
          >
        </li>
        <li class="context-menu__item" @click="() => getDetailBooking(true)">
          <a href="#" class="context-menu__link" data-action="View"
            ><i class="fa fa-eye"></i>Xem chi tiết
            {{ ctxMenuRow?.booking_type_nm }} trong thẻ mới</a
          >
        </li>
        <li
          class="context-menu__item"
          @click="dialogQuickViewBookingVisible = true"
        >
          <a href="#" class="context-menu__link" data-action="View"
            ><i class="fa fa-eye"></i>Xem nhanh các đặt phòng trong
            {{ ctxMenuRow?.booking_type_nm }}</a
          >
        </li>
        <li class="context-menu__item" @click="fnConfirmBooking">
          <a class="context-menu__link" data-action="View">Xác nhận</a>
        </li>
        <li class="context-menu__item" @click="fnConfirmBookingWithDiscount">
          <a class="context-menu__link" data-action="View">Xác nhận (có giảm giá)</a>
        </li>

        <li class="context-menu__item" @click="fnregisterForm">
          <a class="context-menu__link" data-action="View">Phiếu đăng ký</a>
        </li>
      </ul>
    </nav>
    <!-- context menu for Single -->
    <nav
      v-show="ctxMenuStateSingle"
      id="context-menu-single"
      class="context-menu"
    >
      <ul class="context-menu__items">
        <li
          v-show="
            ctxMenuRowSingle?.booking_room_stat === 1 &&
            ctxMenuRowSingle?.room_id
          "
          class="context-menu__item"
          @click="
            if (ctxMenuRowSingle?.room_id) {
              checkinFromCtxMenu = true
              onCheckin()
            } else {
              $message({
                type: 'error',
                message: 'bookingNotAssignedRoomYet'
              })
            }
          "
        >
          <a href="#" class="context-menu__link" data-action="View">Check-in</a>
        </li>
        <li
          v-show="ctxMenuRowSingle?.booking_room_stat === 2"
          class="context-menu__item"
          @click="fnCheckout(ctxMenuRowSingle)"
        >
          <a href="#" class="context-menu__link" data-action="View"
            >Check-out</a
          >
        </li>
        <li
          v-show="
            ctxMenuRowSingle?.booking_room_stat === bookingStatuses.BOOKED ||
            ctxMenuRowSingle?.booking_room_stat === bookingStatuses.CHECKED_IN
          "
          @click="
            selectedRows = [ctxMenuRowSingle]
            onSetBookingMaster()
          "
        >
          <a class="context-menu__link">Đặt phòng chính</a>
        </li>
        <li
          v-show="
            ctxMenuRowSingle?.booking_room_stat === bookingStatuses.BOOKED
          "
          @click="
            selectedRows = [ctxMenuRowSingle]
            onSeparateFromGroup()
          "
        >
          <a class="context-menu__link">Tách khỏi nhóm</a>
        </li>
        <li
          v-show="
            ctxMenuRowSingle?.booking_room_stat === bookingStatuses.CHECKED_IN
          "
          @click="onClickRouting"
        >
          <a class="context-menu__link">Routing</a>
        </li>
        <li
          v-show="
            ctxMenuRowSingle?.booking_room_stat === bookingStatuses.CHECKED_IN
          "
          :disabled="
            !(
              selectedRows.length === 1 &&
              !isHeaderRow(selectedRows[0]) &&
              selectedRows[0]?.room_id
            )
          "
          @click="
            dialogChangeRoomVisible = true
            selectedRows = [ctxMenuRowSingle]
          "
        >
          <a class="context-menu__link">Chuyển phòng</a>
        </li>
        <li
          v-show="
            ctxMenuRowSingle?.booking_room_stat === bookingStatuses.CHECKED_IN
          "
          @click="
            selectedBookingForExtendRoom = { ...ctxMenuRowSingle }
            dialogExtendRoomVisible = true
          "
        >
          <a class="context-menu__link">Gia hạn phòng</a>
        </li>
        <li
          v-show="
            ctxMenuRowSingle?.booking_room_stat ===
              bookingStatuses.CHECKED_IN &&
            ctxMenuRowSingle?.residual_amount === 0
          "
          @click="
            selectedRows = [ctxMenuRowSingle]
            onSetBookingMaster()
          "
        >
          <a class="context-menu__link">Checkout</a>
        </li>
        <li
          v-show="ctxMenuRowSingle?.booking_room_stat === 1"
          class="context-menu__item"
          @click="
            selectedRows = [ctxMenuRow]
            dialogCancelVisible = true
          "
        >
          <a href="#" class="context-menu__link" data-action="View"
            >Hủy đặt phòng</a
          >
        </li>
        <li
          class="context-menu__item"
          @click="dialogBookingRoomDetailVisible = true"
        >
          <a href="#" class="context-menu__link" data-action="View"
            >Xem chi tiết đặt phòng</a
          >
        </li>

        <li
          v-if="
            ctxMenuRowSingle != null &&
            ctxMenuRowSingle.room_id != null &&
            (ctxMenuRowSingle.booking_room_stat === 1 ||
              ctxMenuRowSingle.booking_room_stat === 2)
          "
          class="context-menu__item"
          @click="dialogIssueCardVisible = true"
        >
          <a class="context-menu__link" data-action="View"
            >Quản lý khóa phòng</a
          >
        </li>
      </ul>
    </nav>
    <ChangeRoomDialog
      v-model="dialogChangeRoomVisible"
      :data="dialogChangeRoomVisible ? selectedRows[0] : null"
      @onReloadAfterChangeRoom="onReloadAfterChangeRoom"
    />
    <JoinGroupDialog
      v-model="dialogJoinGroupVisible"
      :data="joinGroupData"
      :group-code="groupCode"
      @resetSearch="onReset"
    />
    <!-- dialog by context menu -->
    <QuickViewBookingDialog
      v-model="dialogQuickViewBookingVisible"
      :booking="ctxMenuRow"
      @onReloadAfterCheckin="onReloadAfterCheckin"
    />
    <BookingRoomDetailDialog
      v-model="dialogBookingRoomDetailVisible"
      :data="ctxMenuRowSingle"
      @onUpdateBookingRoom="onUpdateBookingRoom"
    />
    <ExtendRoomDialog
      v-model="dialogExtendRoomVisible"
      :data="selectedBookingForExtendRoom"
      @refresh="onReset"
    />
    <!-- issue card dialog -->
    <IssueCardDialog
      v-model="dialogIssueCardVisible"
      :data="ctxMenuRowSingle"
    />
  </div>
</template>

<script>
/* eslint-disable */
import {
  getBookingInfo,
  setBookingMaster,
  separateFromGroup,
  joinGroup,
  checkin,
  getJoinGroup
} from '@/api/reception/reception'
import { CellRenderCheckbox } from '@/utils/cellRenders'
import ChangeRoomDialog from '@/views/mci/reception/components/ChangeRoomDialog.vue'
import BookingRoomDetailDialog from '@/views/mci/reception/components/BookingRoomDetailDialog.vue'
import QuickViewBookingDialog from '@/views/mci/reception/components/QuickViewBookingDialog.vue'
import RoutingDialog from '@/views/mci/reception/components/RoutingDialog.vue'
import CancelBookingDialog from '@/views/mci/reception/components/CancelBookingDialog.vue'
import ExtendRoomDialog from '@/views/mci/reception/components/ExtendRoomDialog.vue'
import IssueCardDialog from '@/views/mci/reception/components/IssueCardDialog.vue'

import { mapState } from 'vuex'
import ctxMenuMixin from '@/mixins/ctxMenuMixin'
import paginationMixin from '@/mixins/paginationMixin'
import { getBookingGroupListApi } from '@/api/booking_service/missionBookingGroupApi'
import { getListDebitAccount } from '@/api/configuration/accounting/debitAccount'
import { getAgent, getRoom, getRoomLevel } from '@/api/reception/common'
import { getUserApi } from '@/api/userConfig/user'
import { getSourceListApi } from '@/api/common/source'
import { notifyError, notifySuccess } from '@/utils/toast'
import JoinGroupDialog from '@/views/mci/reception/components/JoinGroupDialog.vue'
import {
  cardRoomCheckoutApi,
  checkoutCustomer
} from '@/api/cashier_service/postTransaction'
export default {
  components: {
    ExtendRoomDialog,
    ChangeRoomDialog,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckbox,
    BookingRoomDetailDialog,
    QuickViewBookingDialog,
    RoutingDialog,
    JoinGroupDialog,
    CancelBookingDialog,
    IssueCardDialog
  },
  mixins: [paginationMixin, ctxMenuMixin],
  props: {
    view: {
      default: 'all',
      validator(value) {
        return ['all', 'arrived_guest', 'in_house_guest']
      }
    }
  },
  data() {
    return {
      columns: [
        {
          headerName: 'Mã',
          // field: 'sub_booking_group_id',
          valueGetter: params => {
            if (params.data.sub_booking_group_id == null) {
              return `${params.data.booking_type_nm}: ${params.data.booking_code}`
            } else {
              return params.data.recode
            }
          },
          colSpan: params => {
            if (!params.data.sub_booking_group_id) {
              return 30
            } else {
              return 1
            }
          },
          cellClassRules: {
            'colspan-cell': params => !params.data.sub_booking_group_id
          }
        },
        {
          headerName: 'Tên khách',
          field: 'formatted_name',
          valueGetter(params) {
            return [params.data?.last_name, params.data?.first_name].join(' ')
          }
        },
        {
          headerName: 'Số điện thoại',
          field: 'phone_number'
        },
        {
          headerName: 'Nguồn',
          field: 'source_desc'
        },
        {
          headerName: 'Trạng thái đặt phòng',
          field: 'booking_room_stat',
          valueFormatter: params => {
            switch (params.value) {
              case 1:
                return 'Đã đặt'
              case 2:
                return 'Đang ở'
              case 3:
                return 'Đã hủy'
              case 4:
                return 'Đã trả phòng'
              default:
                return 'Không xác định'
            }
          }
        },
        {
          headerName: 'Phòng',
          field: 'room_num',
          maxWidth: 100
        },
        {
          headerName: 'Ngày khách đến',
          field: 'arrive_date'
        },
        {
          headerName: 'Ngày khách đi',
          field: 'depart_date'
        },
        {
          headerName: 'Khách sạn',
          field: 'hotel_nm'
        },
        {
          headerName: 'Nhân viên Sales',
          field: 'sales_person_nm'
        },

        {
          headerName: 'Ngày check-in',
          field: 'check_in_time'
        },

        {
          headerName: 'Ngày check-out',
          field: 'check_out_time'
        },
        {
          headerName: 'Đêm',
          field: 'num_of_night',
          maxWidth: 100
        },
        {
          headerName: 'Người lớn',
          field: 'num_of_guest',
          maxWidth: 100
        },
        {
          headerName: 'Trẻ em',
          field: 'child_num',
          maxWidth: 100
        },
        {
          headerName: 'Trẻ em dưới 5 tuổi',
          field: 'u5_child_num',
          maxWidth: 150
        },
        {
          headerName: 'Booking ID',
          field: 'sub_booking_group_id',
          maxWidth: 100
        },
        {
          headerName: 'Xác nhận',
          field: 'is_confirm',
          maxWidth: 100,
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCheckbox'
        },
        {
          headerName: 'Nội bộ',
          field: 'is_internal',
          maxWidth: 100,
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCheckbox'
          // maxWidth: 50
        },
        {
          headerName: 'Phụ thu',
          field: 'room_surcharge'
        },
        {
          headerName: 'Dịch vụ đặc biệt',
          field: 'special_service_nm'
        },
        {
          headerName: 'Miễn phí',
          field: 'is_free',
          maxWidth: 100,
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCheckbox'
        },
        {
          headerName: 'Bình luận',
          field: 'comment'
        },
        {
          headerName: 'Sinh nhật',
          field: 'date_of_birth',
          maxWidth: 200
        },
        {
          headerName: 'Công ty, đại lý du lịch',
          field: 'agent_nm'
        },
        {
          headerName: 'Email',
          field: 'email'
        }
      ],
      bookingStatuses: {
        BOOKED: 1,
        CHECKED_IN: 2,
        CANCELLED: 3,
        CHECKED_OUT: 4
      },
      selectedBookingForExtendRoom: null,
      groupCode: null,
      joinGroupData: [],
      // open dialog
      dialogExtendRoomVisible: false,
      dialogChangeRoomVisible: false,
      dialogJoinGroupVisible: false,
      dialogBookingRoomDetailVisible: false,
      dialogQuickViewBookingVisible: false,
      dialogCheckinVisible: false,
      dialogRoutingVisible: false,
      dialogAddRoutingVisible: false,
      dialogCancelVisible: false,
      dialogCardReaderVisible: false,
      dialogIssueCardVisible: false,
      // search panel
      searchParams: {
        phone: null,
        keyword: null,
        roomLevelId: null,
        roomId: null,
        bookingId: null,
        arriveDateFrom: null,
        arriveDateTo: null,
        departDateFrom: null,
        departDateTo: null,
        createDateFrom: null,
        createDateTo: null,
        firstName: null,
        lastName: null,
        dateOfStay: null,
        salesPersonId: null,
        agentId: null,
        isArriveToDay: true,
        isBooked: true,
        isInHouse: true,
        isCanceled: false,
        isNotArrive: false,
        isCheckout: false
      },
      defaultSearchParams: {
        keyword: null,
        roomLevelId: null,
        roomId: null,
        bookingId: null,
        arriveDateFrom: null,
        arriveDateTo: null,
        departDateFrom: null,
        departDateTo: null,
        createDateFrom: null,
        createDateTo: null,
        firstName: null,
        lastName: null,
        dateOfStay: null,
        agentId: null,
        isArriveToDay: true,
        isBooked: true,
        isInHouse: true,
        isCanceled: false,
        isNotArrive: false,
        isCheckout: false
      },
      // context menu
      ctxMenuState: false,
      ctxMenuRow: null,
      ctxMenuStateSingle: false,
      ctxMenuRowSingle: null,
      // table
      rows: [],
      selectedRows: [],
      loading: false,
      // dialog
      dialogGroupVisible: false,
      dialogAssignRoomVisible: false,
      // group dialog for search
      groupSearchParams: {
        pageSize: 10,
        pageNum: 1,
        totalPage: null,
        orderBy: null,
        orderTp: null,
        info: null,
        agent: null,
        firstArrival: {
          start: null,
          end: null
        },
        lastDepDate: {
          start: null,
          end: null
        },
        roomDate: {
          start: null,
          end: null
        },
        releaseDate: null,
        bookStayOverDate: null,
        status: [],
        isRoomBooking: null,
        isRoomCo: null,
        groupStatus: []
      },
      defaultGroupSearchParams: {
        pageSize: 10,
        pageNum: 1,
        totalPage: undefined,
        orderBy: undefined,
        orderTp: undefined,
        info: undefined,
        agent: undefined,
        firstArrival: {
          start: undefined,
          end: undefined
        },
        lastDepDate: {
          start: undefined,
          end: undefined
        },
        roomDate: {
          start: undefined,
          end: undefined
        },
        releaseDate: undefined,
        bookStayOverDate: undefined,
        status: [],
        isRoomBooking: undefined,
        isRoomCo: undefined,
        groupStatus: []
      },
      groupLoading: false,
      groupColumns: [
        {
          headerName: 'Trạng thái',
          field: 'status'
        },
        {
          headerName: 'Xác nhận',
          field: 'confirm_code'
        },
        {
          headerName: 'Mã đoàn',
          field: 'booking_code'
        },
        {
          headerName: 'Mã định danh ngoài',
          field: 'external_id'
        },
        {
          headerName: 'Tên đoàn',
          field: 'name'
        },
        {
          headerName: 'Đại lý du lịch',
          field: 'agent_name'
        },
        {
          headerName: 'Ngày đến đầu',
          field: 'first_arrival_date'
        },
        {
          headerName: 'Ngày đi cuối',
          field: 'last_departure_date'
        },
        {
          headerName: 'Người tạo',
          field: 'create_user_id'
        },
        {
          headerName: 'Thời gian tạo',
          field: 'create_date'
        },
        {
          headerName: 'Ghi chú',
          field: 'note'
        }
      ],
      groupRows: [],
      groupSelectedRow: null,
      isAssignGuestOptions: [
        { value: null, label: 'Tất cả' },
        { value: false, label: 'Đã gán' },
        { value: true, label: 'Chưa gán' }
      ],
      // multi select
      initAssignStatus: ['Chưa gán'],
      assignStatus: [],
      assignStatusOptions: [
        {
          label: 'Chưa gán',
          value: false
        },
        {
          label: 'Đã gán',
          value: true
        }
      ],
      initGroupStatus: [],
      groupStatusOptions: [
        { value: 1, name: 'Có khách đặt phòng' },
        { value: 2, name: 'Có khách đang ở' },
        { value: 3, name: 'Gồm đoàn trả phòng' },
        { value: 4, name: 'Đoàn bị hủy' },
        { value: 5, name: 'Có khách đã trả phòng' }
      ],
      initRoomStatus: ['Definite', 'Seri', 'Tentative', 'Waiting'],
      // roomStatus: [],
      roomStatusOptions: [
        { value: 1, name: 'Definite' },
        { value: 2, name: 'Tentative' },
        { value: 3, name: 'Seri Booking' },
        { value: 4, name: 'Waiting' }
      ],
      orderByOptions: [
        { label: 'Sắp xếp theo 01', value: 1 },
        { label: 'Sắp xếp theo 02', value: 2 },
        { label: 'Sắp xếp theo 03', value: 3 }
      ],
      orderTypeOptions: [
        { label: 'Không sắp xếp', value: null },
        { label: 'Tăng dần', value: 'asc' },
        { label: 'Giảm dần', value: 'desc' }
      ],
      routingBookingInfo: null,
      checkinFromCtxMenu: false,
      roomLevelOptions: [],
      roomOptions: [],
      salesPersonOptions: [],
      agencyOptions: [],
      bookingOptions: [],
      debitAccOptions: [],
      marketSegOptions: [],
      priceCodeOptions: [],
      nationalityOptions: [],
      marketSegmentOptions: [],
      sourceOptions: [],
      arrival_date_range: {
        start: null,
        end: null
      },
      departure_date_range: {
        start: null,
        end: null
      },
      created_date_range_enabled: false,
      created_date_range: {
        start: null,
        end: null
      }
    }
  },
  computed: {
    ...mapState({
      sidebarState: state => state.app.sidebar.opened
    }),

    filteredRoomOptions() {
      if (
        this.searchParams.roomLevelId == null ||
        this.searchParams.roomLevelId === ''
      ) {
        return this.roomOptions
      }
      return this.roomOptions.filter(
        room => room.room_level_id === this.searchParams.roomLevelId
      )
    }
  },
  watch: {
    created_date_range_enabled: {
      handler(value) {
        this.created_date_range.start = null
        this.created_date_range.end = null
        if (value === false) {
          this.searchParams.createDateTo = null
          this.searchParams.createDateTo = null
        }
      }
    },
    created_date_range: {
      handler(value) {
        if (!this.created_date_range_enabled) {
          value.start = null
          value.end = null
          return
        }
        this.searchParams.createDateFrom = value.start
        this.searchParams.createDateTo = value.end
      },
      deep: true
    },
    arrival_date_range: {
      handler(value) {
        this.searchParams.arriveDateTo = value.start
        this.searchParams.arriveDateFrom = value.end
      },
      deep: true
    },
    departure_date_range: {
      handler(value) {
        this.searchParams.departDateFrom = value.start
        this.searchParams.departDateTo = value.end
      },
      deep: true
    }
  },
  async mounted() {
    // window.isHeaderRow = params => {
    //   return !params.data.sub_booking_group_id
    // }

    Object.assign(this.searchParams, this.defaultSearchParams)
    if (this.view === 'all') {
      Object.assign(this.searchParams, {
        isArriveToDay: true,
        isCanceled: false,
        isInHouse: true,
        isBooked: true,
        isNotArrive: false,
        isCheckout: false
      })
    }
    this.searchParams.bookingId = this.$route.query.recode

    if (this.$route.query.recode) {
      Object.assign(this.searchParams, {
        isArriveToDay: true,
        isCanceled: true,
        isInHouse: true,
        isBooked: true,
        isNotArrive: true,
        isCheckout: true
      })
    }

    if (this.$store.state?.app.route?.params?.recode) {
      this.searchParams.bookingId = this.$store.state?.app.route?.params?.recode
    }
    Promise.all([this.getAgencyOptions(), this.getSourceOptions()])
    this.contextListener()
    this.clickListener()

    this.keyupListener()
    this.resizeListener()
    this.onSearch()
  },
  methods: {
    fnConfirmBooking() {
      const routeData = this.$router.resolve({
        path: '/confirm_booking',
        query: {
          id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code,
          type: this.ctxMenuRow?.type
        }
      })
      window.open(routeData.href, '_blank')
    },
    fnConfirmBookingWithDiscount() {
      const routeData = this.$router.resolve({
        path: '/confirm_booking',
        query: {
          id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code,
          type: this.ctxMenuRow?.type,
          applyDiscount: true
        }
      })
      window.open(routeData.href, '_blank')
    },
    fnregisterForm() {
      const routeData = this.$router.resolve({
        path: '/group/register_form',
        query: {
          id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code,
          type: this.ctxMenuRow?.type
        }
      })
      window.open(routeData.href, '_blank')
    },
    onResizeColumns() {
      this.$refs.agGrid.autoSizeAll()
    },
    onClickRouting() {
      this.routingBookingInfo = this.ctxMenuRowSingle
      this.dialogRoutingVisible = true
    },
    onUpdateBookingRoom() {
      this.dialogBookingRoomDetailVisible = false
      this.onSearch()
    },
    async fnCheckout(data) {
      await checkoutCustomer({ ids: [data?.sub_booking_group_id] })
        .then(data => {
          if (!data.is_error) {
            notifySuccess(data.message)

            this.onReset()
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          notifyError(error.response?.data?.message)
        })
        .finally(() => {})
      await cardRoomCheckoutApi()
    },
    onReloadAfterCheckin() {
      this.onSearch()
    },
    getDetailBooking(isNewTab = false) {
      if (this.ctxMenuRow?.booking_type_nm === 'Đoàn') {
        if (isNewTab) {
          const routeData = this.$router.resolve({
            path: '/group/new_group_master',
            query: {
              action: 'edit',
              id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
            }
          })
          window.open(routeData.href, '_blank')
        } else {
          this.$router.push({
            path: '/group/new_group_master',
            query: {
              action: 'edit',
              id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
            }
          })
        }
      } else {
        if (isNewTab) {
          const routeData = this.$router.resolve({
            path: '/reservation/new_reservation',
            query: {
              action: 'edit',
              id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
            }
          })
          window.open(routeData.href, '_blank')
        } else {
          this.$router.push({
            path: '/reservation/new_reservation',
            query: {
              action: 'edit',
              id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
            }
          })
        }
      }
    },
    onReloadAfterChangeRoom() {
      this.onSearch()
    },
    openInNewTab() {
      const routeData = this.$router.resolve({
        path: '/reservation/new_reservation',
        query: {
          action: 'edit',
          id: this.ctxMenuRow?.booking_id || this.ctxMenuRow?.booking_code
        }
      })
      window.open(routeData.href, '_blank')
    },
    fnSetBookingMaster(bookingId) {
      this.$vxConfirm(
        `Xác nhận đặt phòng chính cho mã đặt phòng ${bookingId}?`,
        () => {
          setBookingMaster({ isMaster: true, bookingId: bookingId })
            .then(data => {
              if (!data.is_error) {
                const message = data?.message
                notifySuccess(message)

                this.onReset()
              } else {
                throw new Error(data)
              }
            })
            .catch(error => {
              const message = error.response?.data?.message
              notifyError(message)
            })
            .finally(() => {})
        }
      )
    },
    fnSeparateFromGroup(bookingId) {
      this.$vxConfirm(
        `Xác nhận tách mã đặt phòng ${bookingId} ra khỏi nhóm?`,
        () => {
          separateFromGroup({ bookingId: bookingId })
            .then(data => {
              if (!data.is_error) {
                notifySuccess(data.message)

                this.onReset()
              } else {
                throw new Error(data)
              }
            })
            .catch(error => {
              notifyError(error.response?.data?.message)
            })
        }
      )
    },
    fnJoinGroup(bookingId1, bookingId2) {
      this.$vxConfirm(
        `Xác nhận ghép mã đặt phòng ${bookingId1} và ${bookingId2}?`,
        () => {
          joinGroup({
            bookingGroupId1: bookingId1,
            bookingGroupId2: bookingId2
          })
            .then(data => {
              if (!data.is_error) {
                notifySuccess(data.message)

                this.onReset()
              } else {
                throw new Error(data)
              }
            })
            .catch(error => {
              notifyError(error.response?.data?.message)
            })
        }
      )
    },
    fnCheckin(data) {
      checkin(data)
        .then(data => {
          if (!data.is_error) {
            notifySuccess(data.message)

            this.onSearch()
          } else {
            // throw new Error(data)
            notifyError(data?.message)
          }
        })
        .catch(error => {
          notifyError(error.response?.data?.message)
        })
    },
    // handle context menu:
    // listener
    contextListener() {
      // apply only be call in updated()
      // document.querySelectorAll('.ag-full-width-row').forEach(item => {
      //   item.addEventListener('contextmenu', e => {
      //     // open context menu
      //     this.toggleMenuOn()
      //     this.positionMenu(e)

      //     e.preventDefault()
      //   })
      // })

      document.addEventListener('contextmenu', e => {
        const row = this.clickInsideCtxMenu(e, 'agGrid')
        if (
          row &&
          (e.target.classList.contains('ag-cell') ||
            e.target.classList.contains('ag-row'))
        ) {
          if (e.target.classList.contains('colspan-cell')) {
            this.positionMenu(e, '#context-menu')
            // open contextmenu
            this.ctxMenuState = true
            this.ctxMenuStateSingle = false
          } else {
            this.positionMenu(e, '#context-menu-single')
            // open contextmenu
            this.ctxMenuStateSingle = true
            this.ctxMenuState = false
          }

          e.preventDefault()
        } else {
          this.ctxMenuState = false
          this.ctxMenuStateSingle = false
        }
      })
    },
    clickListener() {
      document.addEventListener('click', e => {
        // const clickedElIsItem = this.clickInsideCtxMenu(
        //   e,
        //   'context-menu__link'
        // )

        // if (clickedElIsItem) {
        //   e.preventDefault()
        //   // handle event in context menu
        //   console.log('you click data', this.ctxMenuRow)
        //   this.dialogQuickViewBookingVisible = true
        // }
        // e.stopImmediatePropagation()
        // e.stopPropagation()
        // this.ctxMenuState = false

        this.ctxMenuState = false
        this.ctxMenuStateSingle = false
      })
    },
    // for ag grid
    handleOpenContextMenu(event) {
      if (!event.data?.sub_booking_group_id) {
        this.ctxMenuRow = event.data
      } else {
        this.ctxMenuRowSingle = event.data
        this.ctxMenuRow = event.data
      }
    },
    keyupListener() {
      window.onkeyup = e => {
        if (e.keyCode === 27) {
          this.ctxMenuState = false
          this.ctxMenuStateSingle = false
        }
      }
    },
    resizeListener() {
      window.onresize = e => {
        this.ctxMenuState = false
        this.ctxMenuStateSingle = false
      }
    },
    // utils
    isHeaderRow(obj) {
      return !obj?.sub_booking_group_id
    },
    // handle event
    // pagination
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetAssignRoom()
    },
    onSelectionChanged(selectedRows) {
      // console.log(selectedRows)
      this.selectedRows = selectedRows
    },
    // handle button
    onSetBookingMaster() {
      this.fnSetBookingMaster(this.selectedRows[0].sub_booking_group_id)
    },
    onSeparateFromGroup() {
      this.fnSeparateFromGroup(this.selectedRows[0].sub_booking_group_id)
    },
    onJoinGroup() {
      this.fnGetJoinGroup(
        this.selectedRows[0].booking_code,
        this.selectedRows[1].booking_code
      )
    },
    fnGetJoinGroup(bookingCode1, bookingCode2) {
      if (this.selectedRows[0].type === this.selectedRows[1].type) {
        if (this.selectedRows[0].type === '3') {
          this.groupCode = null // the two are khach le
        }
        if (this.selectedRows[0].type === '1') {
          this.groupCode = this.selectedRows[0]?.booking_code // the two are nhom
        }
      } else {
        this.selectedRows[0].type === '1'
          ? (this.groupCode = this.selectedRows[0]?.booking_code)
          : (this.groupCode = this.selectedRows[1]?.booking_code)
        // if (this.selectedRows[0].type === '1') {
        //   this.groupCode = this.selectedRows[0]?.booking_code
        // }
        // if (this.selectedRows[1].type === '1') {
        //   this.groupCode = this.selectedRows[1]?.booking_code
        // }
      }
      getJoinGroup({ bookingCode1, bookingCode2 })
        .then(data => {
          if (!data.is_error) {
            this.joinGroupData = [...data.data]
            this.dialogJoinGroupVisible = true
          } else {
            throw new Error(data)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    onChangeRoomLevel() {
      this.searchParams.roomId = null
    },
    onChangeRoom(value) {
      const selectedRoom = this.roomOptions.find(room => room.id === value)
      if (selectedRoom) {
        this.searchParams.roomLevelId = selectedRoom.room_level_id
      }
    },
    // handle event
    onSelectGroup(data) {
      this.searchParams.bookingId = data?.id || null
    },
    onSelectRoomLevel(data) {
      this.searchParams.roomLevelId = data?.id || null
    },
    onCheckin() {
      this.fnCheckin(
        this.checkinFromCtxMenu
          ? [this.ctxMenuRowSingle?.sub_booking_group_id]
          : this.selectedRows.map(item => item?.sub_booking_group_id)
      )
      this.checkinFromCtxMenu = false
    },
    onCancel() {
      console.log(this.selectedRows)
      let checkSameinBooking = this.selectedRows.every(
        val => val.booking_code == this.selectedRows[0].booking_code
      )
      // console.log(checkSameinBooking)
      if (!checkSameinBooking) {
        this.$message({
          message: 'Không thể hủy đặt phòng khác Nhóm hoặc Đoàn',
          type: 'error'
        })
      } else {
        this.dialogCancelVisible = true
      }
    },
    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetAssignRoom()
    },
    onSearch() {
      // if (this.view === 'arrived_guest') {
      //  this.searchParams.isBooked = true
      // } else if (this.view === 'in_house_guest') {
      //  this.searchParams.isInHouse = true
      // }
      Object.keys(this.searchParams).forEach(key => {
        if (this.searchParams[key] === false) {
          this.searchParams[key] = null
        } else if (this.searchParams[key] === '') {
          this.searchParams[key] = null
        }
      })
      this.fnGetAssignRoom()
    },
    onResetCancel() {
      this.onSearch()
    },
    onReset() {
      this.onResetSearch()
    },
    onResetSearch() {
      this.arrival_date_range = null
      this.departure_date_range = null
      this.searchParams = { ...this.defaultSearchParams }
      this.onSearch()
    },
    fnGetAssignRoom() {
      const query = {
        ...this.searchParams,
        pageSize: this.pageParams.pageSize,
        pageNum: this.pageParams.pageNum
      }
      this.loading = true
      getBookingInfo(query)
        .then(res => {
          if (!res.is_error) {
            this.rows = res.data

            this.pageParams.pageNum = res.page_num
            this.pageParams.totalPage = Math.ceil(res.total / res.page_size)
            setTimeout(() => {
              this.$refs.agGrid.autoSizeAll()
            }, 0)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    // Select options API calls
    async getDebitOptions() {
      await getListDebitAccount().then(response => {
        this.debitAccOptions = response.data
      })
    },
    async getGroupOptions() {
      await getBookingGroupListApi().then(response => {
        this.groupOptions = response.data
      })
    },
    async getRoomLevelOptions() {
      await getRoomLevel().then(res => {
        this.roomLevelOptions = res.data
      })
    },
    async getRoomOptions() {
      await getRoom().then(res => {
        this.roomOptions = res.data
      })
    },
    async getSalesPersonOptions() {
      await getUserApi().then(response => {
        this.salesPersonOptions = response.data.map(person => ({
          label: person.account.full_name,
          value: person.account.id
        }))
      })
    },
    onViewBooking() {
      const recode = this.ctxMenuRowSingle.recode
      this.$router.push(`/reservation/new_reservation?action=edit&id=${recode}`)
    },
    async getSourceOptions() {
      await getSourceListApi({ isActive: 1 }).then(response => {
        this.sourceOptions = response.data
      })
    },
    async getAgencyOptions() {
      await getAgent()
        .then(response => {
          this.agencyOptions = response.data
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
